import { useState } from "react";
import DiscountsList from "./components/DiscountsList/DiscountsList";
import { DiscountsListingProvider } from "./context/DiscountsListingContext";
import Filters from "./components/Filters/Filters";
import DiscountsSearch from "./components/DiscountsSearch/DiscountsSearch";
import DiscountsHero from "./components/DiscountsHero/DiscountsHero";
import "./DiscountsListing.css";

export default function DiscountsListing() {
  const [filters, setFilters] = useState({});
  return (
    <DiscountsListingProvider value={{ filters, setFilters }}>
      <div className="bg-background-minimal flex h-full flex-col gap-4">
        <div className="discounts-listing-gradient relative isolate flex w-full flex-col gap-5 px-5 pt-10 md:px-20 md:pt-10">
          <DiscountsHero />
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex w-full justify-between gap-2">
              <div className="md:max-w-100 flex-1 h-full">
                <DiscountsSearch name="name" />
              </div>
              <div>
                <Filters />
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col gap-4 px-5 pb-10 md:px-20">
          <DiscountsList />
        </div>
      </div>
    </DiscountsListingProvider>
  );
}
